import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export { Step };
export default Steps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-steps/es/index.js
// module id = 683
// module chunks = 0 1